<template>
  <div>
    <Head title="Create Airport" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/settings">Settings</Link></li>
        <li class="breadcrumb-item"><Link href="/settings/types">Types</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Create Type</li>
      </ol>
    </nav>
    <h1>Create Type</h1>

    <div class="content-box">
      <form @submit.prevent="store">
        <TypeForm :form="form" />

        <div class="actions-toolbar">
          <loading-button :loading="form.processing" class="btn btn-primary" type="submit">Create Type</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TypeForm from './components/TypeForm'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    TypeForm,
    LoadingButton
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/settings/types')
    },
  },
}
</script>
